import React, { useState, useEffect } from "react";
import { getSignedUrl } from "../services/getSignedUrl";

export default function ImageCarousel({ files, height = 180, borderRadius = "0" }) {
  const [current, setCurrent] = useState(0);
  const [signedSrc, setSignedSrc] = useState(null);

  const file = files?.[current];

  useEffect(() => {
    if (!file) return;
    if (file?.publicId) {
      getSignedUrl(file.publicId, file.isVideo ? "video" : "image")
        .then(url => setSignedSrc(url));
    } else {
      setSignedSrc(file?.url || file?.dataUrl);
    }
  }, [file?.publicId, file?.url]);

  if (!files || files.length === 0) {
    return (
      <div style={{...s.empty, height, borderRadius}}>
        <span style={{fontSize:32}}>📷</span>
        <span style={{fontSize:11,color:"#aaa",marginTop:4}}>Sin imagen</span>
      </div>
    );
  }

  const prev = (e) => { e.stopPropagation(); setCurrent(i => (i - 1 + files.length) % files.length); };
  const next = (e) => { e.stopPropagation(); setCurrent(i => (i + 1) % files.length); };

  const isVideo = file?.isVideo || file?.type?.startsWith("video");
  const src = signedSrc || file?.dataUrl;

  if (!src) return (
    <div style={{...s.empty, height, borderRadius}}>
      <span style={{fontSize:32}}>📷</span>
    </div>
  );

  return (
    <div style={{...s.wrapper, height, borderRadius}}>
      {file?.uploading && (
        <div style={s.progressOverlay}>
          <div style={s.progressBar}>
            <div style={{...s.progressFill, width:`${file.progress||0}%`}} />
          </div>
          <p style={s.progressText}>Subiendo... {file.progress||0}%</p>
        </div>
      )}

      {isVideo ? (
        <video key={src} src={src} style={{...s.media, borderRadius}} controls playsInline preload="metadata" onClick={e => e.stopPropagation()} />
      ) : (
        <img src={src} alt={`foto-${current+1}`} style={{...s.media, borderRadius}} />
      )}

      {files.length > 1 && (
        <>
          <button style={{...s.arrow, left:8}} onClick={prev}>‹</button>
          <button style={{...s.arrow, right:8}} onClick={next}>›</button>
        </>
      )}

      {files.length > 1 && (
        <div style={s.dots}>
          {files.map((_, i) => (
            <button key={i} style={{...s.dot,...(i===current?s.dotActive:{})}} onClick={e => { e.stopPropagation(); setCurrent(i); }} />
          ))}
        </div>
      )}

      {files.length > 1 && (
        <div style={s.counter}>{isVideo?"🎥":"📷"} {current+1}/{files.length}</div>
      )}
    </div>
  );
}

const s = {
  wrapper:{position:"relative",background:"#f5f5f5",overflow:"hidden",display:"flex",alignItems:"center",justifyContent:"center"},
  empty:{background:"#f5f5f5",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"},
  media:{width:"100%",height:"100%",objectFit:"contain"},
  progressOverlay:{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",zIndex:5,gap:10},
  progressBar:{width:"70%",height:8,background:"rgba(255,255,255,0.3)",borderRadius:4,overflow:"hidden"},
  progressFill:{height:"100%",background:"#1D9E75",borderRadius:4,transition:"width 0.3s"},
  progressText:{color:"#fff",fontSize:13,fontWeight:500},
  arrow:{position:"absolute",top:"50%",transform:"translateY(-50%)",background:"rgba(0,0,0,0.5)",color:"#fff",border:"none",borderRadius:"50%",width:34,height:34,fontSize:22,cursor:"pointer",zIndex:4},
  dots:{position:"absolute",bottom:8,left:0,right:0,display:"flex",justifyContent:"center",gap:5},
  dot:{width:7,height:7,borderRadius:"50%",background:"rgba(255,255,255,0.5)",border:"none",cursor:"pointer",padding:0},
  dotActive:{background:"#fff",transform:"scale(1.2)"},
  counter:{position:"absolute",top:8,right:8,background:"rgba(0,0,0,0.5)",color:"#fff",fontSize:11,padding:"3px 8px",borderRadius:20,zIndex:4},
};